export const apiKey = "0a6vqefxba";
export const integrations_apiKey = "h1rdrrtptb";

const query = {
  // baseURL: 'https://'+ apiKey +'.execute-api.eu-west-1.amazonaws.com/v3_0_01',
  baseURL: "http://localhost:3001",
  commandMiddlewareURL: "https://middleware.command.dev-dttsynergy.com/api",
  middlewareURL: "https://middleware.dev-dttsynergy.com/api",
  path: {
    configurations: "/configurations/filters_module",
    dropdown_contents: "/configurations/dropdowns",
    // filterTypes: '/filter-types'
    saved_filters: "/configurations/saved_filters",
    charts: "/configurations/charts",
    currentWeather: "/weather/current",
    forecastWeather: "/weather/forecast",
    globalConfiguration: "/videowall/global_configuration",
    numberOfYearsDropdown: "/configurations/numberOfYearsForTheDropDown",
    municipalitiesDropdown: "/configurations/getMunicipalitiesForTheDropdown",
    energyTypesDropdown: "/configurations/energyTypesForTheDropdown",

    //home
    entinties: "/unified_temporary/home/entities",
    subEntities: "/unified_temporary/home/subEntities",
    territoryHeatmap: "/unified_temporary/home/territoryMap",

    //map data
    mapConfiguration: "/configurations/mapConfigurations",
    incidents: "/videowall/incidents",
    realtimeBus: "/videowall/realtime_bus",
    cityPolygons: "/configurations/city_polygons",
    mapItems: "/unified_temporary/map/getMapItems",
    mapEvents: "/unified_temporary/events/getMapEvents",

    //registry
    basicTableData: "/unified/registry/getRegistryItems",
    registryDetail: "/unified/registry/getRegistryItemById",
    relatedLinks: "/unified/registry/getRelatedLinks",
    registryMap: "/unified/registry/getRegistryMapItems",
    generateReport: "/unified/registry/generateReport",
    detailEnergyActivePower: "/unified/registry/detailEnergyActivePower",
    detailEnergyInductiveReactive:
      "/unified/registry/detailEnergyInductiveReactive",
    detailEnergyReactiveCapacitive:
      "/unified/registry/detailEnergyReactiveCapacitive",
    detailRegistryProduction: "/unified/registry/detailRegistryProduction",
    weekAverageConsumption: "/unified/registry/weekAverageConsumption",
    detailLoadingDiagrams: "/unified/registry/detailLoadingDiagrams",
    detailGasConsumption: "/unified/registry/detailGasConsumption",
    exportRawData: "/unified/registry/exportRawData",
    getRegistryDetailSimulation:
      "/unified/registry/getRegistryDetailSimulation",
    getCerteficatesListById: "/unified/registry/getCerteficatesListById",
    getCertificateDocument: "/unified/registry/getCertificateDocument",
    addCertificateDocument: "/unified/registry/addCertificateDocument",
    detailRegistryEvents: "/unified/registry/detailRegistryEvents",
    deleteCertificateDocument: "/unified/registry/deleteCertificateDocument",
    downloadCertificateDocument: "/graph/items/certificates/",
    searchByCPE: "/unified/registry/getItemByName",

    detailActiveLoadConsumption: "unified/registry/loadDiagramActivePower",
    detailReactiveLoadConsumption: "unified/registry/loadDiagramReactivePower",
    detailBigNumbersLoadConsumption: "unified/registry/loadDiagramBigNumbers",

    detailActivePeakLoad: "/unified/registry/loadPeakActivePower",
    detailProductionPeakLoad: "/unified/registry/loadPeakProductionPower",
    detailInductivePeakLoad: "/unified/registry/loadPeakInductivePower",
    detailCapacitivePeakLoad: "/unified/registry/loadPeakCapacitivePower",
    detailBigNumbersPeakLoad: "/unified/registry/loadPeaksBigNumbers",

    detailConsumptionVSProduction:
      "/unified/registry/monthlyDailyAnalysisPower",

    //analitics
    analiticComplexTable: "/unified_temporary/analytics/getRegistryItems",
    analiticServices: "/unified_temporary/analytics/services",
    analiticPeriodicity: "/unified_temporary/analytics/periodicity",
    analiticLineChart: "/unified_temporary/analytics/analyticsLineChart",

    //configurations
    usersList: "/configurations/getUsersList",
    manageUser: "/configurations/manageUser",

    //Ciris
    emissionsBySector: "/unified_temporary/ciris/emissionsBySector",
    emissionsByScope: "/unified_temporary/ciris/emissionsByScope",

    //Buildings
    buildingConfort: "/unified_temporary/buildings/confort",
    buildingParking: "/unified_temporary/buildings/parking",
    buildingEnergy: "/unified_temporary/buildings/energy",
    buildingsOcupationMaps: "/unified_temporary/buildings/ocupation",

    //Digital Twin
    providersData: "/providers",
    dependentsData: "/dependents",

    //Create Incidents
    getIncidentProperties: "/incidents/properties",
    getIncidentCategories: "/incidents/categories",
    createIncident: "/incidents/command",

    // Item
    getSubtenants: "/items/subtenants",
    getDistinctProperties: "/items/distinct-properties",
    getItems: "/items",
  },
};

export default query;
